// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/gallery7.jpg"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Mercedes Benz Places by Binghatti  
          </h2>
          <p>
            Binghatti Mercedes Benz Places – Binghatti City is an AED 30 billion master-planned development in Meydan, Dubai, created by Binghatti Developers in collaboration with Mercedes-Benz. Spanning over 10 million sq ft, it is the world’s first Mercedes-Benz branded city. The 65-storey, 341-metre tower offers luxury apartments and penthouses with 4.2-metre ceilings, private pools, and Burj Khalifa views. Inspired by Mercedes-Benz’s “Sensual Purity” design, the project integrates smart homes, mobility solutions, retail, wellness, and leisure within a self-sustained urban community.
          </p>
          <button onClick={openModal} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
